import { env } from '$lib/config/environment';
import { PixelService } from './service';
import { PixelServiceMeta } from './service_meta';
import { PixelServiceMock } from './service_mock';

let pixelInstance: PixelService | null = null;

export function createPixelService(): PixelService {
  if (pixelInstance) {
    return pixelInstance;
  }

  if (env.features.mockServices || !env.metaPixel.enabled) {
    pixelInstance = new PixelServiceMock();
  } else {
    pixelInstance = new PixelServiceMeta();
  }

  return pixelInstance;
}

export { PixelService } from './service';
export type { PixelService as IPixelService };
